import IntersectionObserverSSR from "../Layout/Resource/IntersectionObserverSSR";
import {memo, useMemo} from "react";

export const SeoInfo = memo(({htmlRelatedContent}) => {
    const content = useMemo(() => <div dangerouslySetInnerHTML={{__html: htmlRelatedContent}}/>, [htmlRelatedContent])
    return (
        <section className="seo-infos">
            <IntersectionObserverSSR>
                {content}
            </IntersectionObserverSSR>
        </section>
    )
})